import styled, { css } from 'styled-components';
import { border, color, flexbox, layout, position, space, background, shadow, typography, grid } from 'styled-system';

export const Flex = styled.div`
  ${({ pointer, transform, direction }) => css`
    display: flex;
    ${pointer && 'cursor: pointer;'}
    ${transform && `transform: ${transform};`}
    ${direction && `direction: ${direction};`}

    font-family: 'Diatype';
    font-weight: 400;

    ${grid};
    ${typography};
    ${shadow};
    ${background}
    ${border};
    ${color};
    ${flexbox};
    ${layout};
    ${position};
    ${space};
  `}
`;
